module.exports = "mutation DeleteOrder($id: ID!) {\n  deleteOrder(id: $id) {\n    deleted\n  }\n}\n"